import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import styles from './LegalScreen.module.css';

const CONTACT_EMAIL = 'bolaosupport@gmail.com';

export default function TermsScreen() {
  const { t } = useTranslation();

  return (
    <main className="screen">
      <Link to="/" className="muted">
        {t('common.back')}
      </Link>

      <div>
        <h1>{t('terms.title')}</h1>
        <p className="muted" style={{ fontSize: '0.8rem' }}>
          {t('terms.updated')}
        </p>
      </div>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.whatTitle')}</h2>
        <p className={styles.body}>{t('terms.whatBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.accountsTitle')}</h2>
        <p className={styles.body}>{t('terms.accountsBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.conductTitle')}</h2>
        <p className={styles.body}>{t('terms.conductBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.contentTitle')}</h2>
        <p className={styles.body}>{t('terms.contentBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.warrantyTitle')}</h2>
        <p className={styles.body}>{t('terms.warrantyBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.changesTitle')}</h2>
        <p className={styles.body}>{t('terms.changesBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('terms.contactTitle')}</h2>
        <p className={styles.body}>{t('terms.contactBody', { email: CONTACT_EMAIL })}</p>
      </section>
    </main>
  );
}
